// frontend/src/components/dashboard/sidebar.jsx
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const Sidebar = () => {
  const { logout } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      await logout();
      navigate("/login", { replace: true });
    } catch (err) {
      console.error("Logout Error: ", err);
      await logout();
    } finally {
      setIsLoading(false);
    }
  };

  const linkClass = ({ isActive }) =>
    `nav-link py-2 px-3 rounded ${
      isActive ? "active bg-dark text-white" : "text-dark"
    }`;

  return (
    <nav className="d-flex flex-column vh-100 bg-light p-3 border-end col-3 position-sticky top-0">
      <section>
        <NavLink to="allposts" className={linkClass}>
          POSTS
        </NavLink>
      </section>

      <section className="mt-2">
        <NavLink to="addNewPost" className={linkClass}>
          ADD NEW POST
        </NavLink>
      </section>

      {/* NEW: Profile link */}
      <section className="mt-2">
        <NavLink to="profile" className={linkClass}>
          PROFILE
        </NavLink>
      </section>
      <section className="mt-2">
        <NavLink to="reviews" className={linkClass}>
          REVIEWS
        </NavLink>
      </section>

      <button
        onClick={handleLogout}
        className="btn btn-danger w-100 mt-auto rounded-0"
        disabled={isLoading}
      >
        {isLoading ? "Logging out..." : "Logout"}
      </button>
    </nav>
  );
};

export default Sidebar;
